// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.Footer_footer__CmMBU {
  margin-top: 0;
  background: #F7F5F1;
  border-top: 1px solid rgba(16, 25, 21, 0.08);
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.Footer_footer__wrap__tuuWK {
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 34px 40px 26px;
}
@media (max-width: 1100px) {
  .Footer_footer__wrap__tuuWK {
    padding-left: 28px;
    padding-right: 28px;
  }
}
@media (max-width: 760px) {
  .Footer_footer__wrap__tuuWK {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.Footer_footer__top__HFgh8 {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto;
  align-items: start;
  column-gap: 48px;
  row-gap: 24px;
  padding-bottom: 26px;
}
@media (max-width: 1100px) {
  .Footer_footer__top__HFgh8 {
    grid-template-columns: minmax(240px, 1fr) auto;
    column-gap: 32px;
  }
}
@media (max-width: 900px) {
  .Footer_footer__top__HFgh8 {
    grid-template-columns: 1fr;
  }
}
.Footer_footer__brand__YCxI1 {
  min-width: 0;
}
@media (max-width: 760px) {
  .Footer_footer__brand__YCxI1 {
    text-align: center;
  }
}
.Footer_footer__brand__YCxI1 img {
  width: auto;
  height: 58px;
  max-width: none;
}
@media (max-width: 1100px) {
  .Footer_footer__brand__YCxI1 img {
    height: 48px;
  }
}
@media (max-width: 760px) {
  .Footer_footer__brand__YCxI1 img {
    height: 46px;
    margin: 0 auto;
  }
}
@media (max-width: 900px) {
  .Footer_footer__brand__YCxI1 img {
    margin: 0 auto;
  }
}
.Footer_footer__brand__YCxI1 p {
  margin: 18px 0 0;
  max-width: 34ch;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(19, 35, 29, 0.68);
}
@media (max-width: 900px) {
  .Footer_footer__brand__YCxI1 p {
    margin: 0 auto;
  }
}
.Footer_footer__aside__Q-c9k {
  width: 360px;
  display: grid;
  grid-template-columns: 170px 118px;
  column-gap: 42px;
  justify-content: end;
  justify-self: end;
  align-items: start;
  margin-top: 34px;
}
@media (max-width: 1100px) {
  .Footer_footer__aside__Q-c9k {
    width: 330px;
    grid-template-columns: 156px 110px;
    column-gap: 32px;
  }
}
@media (max-width: 900px) {
  .Footer_footer__aside__Q-c9k {
    width: 100%;
    margin-top: 0;
    justify-content: space-around;
    justify-self: start;
  }
}
@media (max-width: 760px) {
  .Footer_footer__aside__Q-c9k {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.Footer_footer__nav-section__JDQV5 {
  width: 100%;
  display: grid;
  gap: 10px;
}
@media (max-width: 760px) {
  .Footer_footer__nav-section__JDQV5 {
    gap: 5px;
    text-align: center;
  }
}
.Footer_footer__nav-section__JDQV5 h3 {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: 0.02em;
  color: #13231D;
  font-weight: 700;
}
.Footer_footer__nav-section__JDQV5 a {
  display: block;
  font-size: 14px;
  line-height: 1.55;
  color: #13231D;
  text-decoration: none;
  transition: color 0.2s ease;
}
.Footer_footer__legal-link__h6K8n {
  font-size: 14px;
  line-height: 1.55;
  color: #13231D;
  text-decoration: none;
}
.Footer_footer__contact__cZxwV {
  font-size: 14px;
  line-height: 1.55;
  color: #13231D;
  text-decoration: none;
}
.Footer_footer__copy__6ju2J {
  font-size: 14px;
  line-height: 1.55;
  color: #13231D !important;
  text-decoration: none;
}
.Footer_footer__bottom_legal-section__F61PI {
  font-size: 14px;
}
.Footer_footer__bottom__1IfmQ {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  margin-top: 0;
  padding-top: 20px;
  gap: 12px 24px;
  border-top: none;
}
.Footer_footer__bottom__1IfmQ::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(92%, 1200px);
  height: 1px;
  background: linear-gradient(90deg, rgba(16, 25, 21, 0) 0%, rgba(16, 25, 21, 0.05) 14%, rgba(16, 25, 21, 0.1) 50%, rgba(16, 25, 21, 0.05) 86%, rgba(16, 25, 21, 0) 100%);
}
.Footer_footer__bottom__1IfmQ > div:first-child {
  justify-self: start;
  text-align: left;
}
.Footer_footer__bottom__1IfmQ > :nth-child(2) {
  justify-self: end;
  text-align: right;
  max-width: none;
}
@media (max-width: 900px) {
  .Footer_footer__bottom__1IfmQ {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .Footer_footer__bottom__1IfmQ::before {
    width: min(88%, 520px);
  }
  .Footer_footer__bottom__1IfmQ > div:first-child, .Footer_footer__bottom__1IfmQ > :nth-child(2) {
    justify-self: center;
    text-align: center;
    max-width: none;
  }
}
.Footer_footer__legal-link__h6K8n, .Footer_footer__contact__cZxwV, .Footer_footer__copy__6ju2J {
  line-height: 1.55;
  color: rgba(19, 35, 29, 0.68);
  text-decoration: none;
}
.Footer_footer__copy__6ju2J {
  white-space: nowrap;
  text-wrap: nowrap;
}
@media (max-width: 900px) {
  .Footer_footer__copy__6ju2J {
    white-space: normal;
    text-wrap: balance;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/Footer/Footer.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,aAAA;EACA,mBDeqB;ECdrB,4CAAA;EACA,WAAA;EACA,oFDDU;ACkBZ;AAfE;EACE,wBAAA;EACA,cAAA;EACA,uBAAA;AAiBJ;AAfI;EALF;IAMI,kBAAA;IACA,mBAAA;EAkBJ;AACF;AAhBI;EAVF;IAWI,kBAAA;IACA,mBAAA;EAmBJ;AACF;AAhBE;EACE,aAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AAkBJ;AAhBI;EARF;IASI,8CAAA;IACA,gBAAA;EAmBJ;AACF;AAjBI;EAbF;IAcI,0BAAA;EAoBJ;AACF;AAjBE;EACE,YAAA;AAmBJ;AAjBI;EAHF;IAII,kBAAA;EAoBJ;AACF;AAlBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAoBN;AAlBM;EALF;IAMI,YAAA;EAqBN;AACF;AAnBM;EATF;IAUI,YAAA;IACA,cAAA;EAsBN;AACF;AApBM;EAdF;IAeI,cAAA;EAuBN;AACF;AApBI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,6BDhDiB;ACsEvB;AApBM;EAPF;IAQI,cAAA;EAuBN;AACF;AAnBE;EACE,YAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAqBJ;AAnBI;EAVF;IAWI,YAAA;IACA,kCAAA;IACA,gBAAA;EAsBJ;AACF;AApBI;EAhBF;IAiBI,WAAA;IACA,aAAA;IACA,6BAAA;IACA,mBAAA;EAuBJ;AACF;AArBI;EAvBF;IAwBI,0BAAA;IACA,aAAA;EAwBJ;AACF;AArBE;EACE,WAAA;EACA,aAAA;EACA,SAAA;AAuBJ;AArBI;EALF;IAMI,QAAA;IACA,kBAAA;EAwBJ;AACF;AAtBI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cDtGiB;ECuGjB,gBAAA;AAwBN;AArBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cD9GiB;EC+GjB,qBAAA;EACA,2BAAA;AAuBN;AAjBE;EACE,eAAA;EACA,iBAAA;EACA,cDzHmB;EC0HnB,qBAAA;AAmBJ;AAdE;EACE,eAAA;EACA,iBAAA;EACA,cDlImB;ECmInB,qBAAA;AAgBJ;AAXE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAaJ;AARE;EACE,eAAA;AAUJ;AANE;EACE,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAQJ;AANI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,uKAAA;AAQN;AALI;EACE,mBAAA;EACA,gBAAA;AAON;AAJI;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;AAMN;AAHI;EAhCF;IAiCI,0BAAA;IACA,SAAA;EAMJ;EAJI;IACE,sBAAA;EAMN;EAHI;IAEE,oBAAA;IACA,kBAAA;IACA,eAAA;EAIN;AACF;AAAE;EAGE,iBAAA;EACA,6BDzMmB;EC0MnB,qBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,iBAAA;AADJ;AAGI;EAJF;IAKI,mBAAA;IACA,kBAAA;EAAJ;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.footer {\n  margin-top: 0;\n  background: $color-surface;\n  border-top: 1px solid $color-border;\n  width: 100%;\n  font-family: $font-main;\n\n  &__wrap {\n    width: min(100%, 1280px);\n    margin: 0 auto;\n    padding: 34px 40px 26px;\n\n    @media (max-width: 1100px) {\n      padding-left: 28px;\n      padding-right: 28px;\n    }\n\n    @media (max-width: 760px) {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }\n\n  &__top {\n    display: grid;\n    grid-template-columns: minmax(280px, 1fr) auto;\n    align-items: start;\n    column-gap: 48px;\n    row-gap: 24px;\n    padding-bottom: 26px;\n\n    @media (max-width: 1100px) {\n      grid-template-columns: minmax(240px, 1fr) auto;\n      column-gap: 32px;\n    }\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__brand {\n    min-width: 0;\n\n    @media (max-width: 760px) {\n      text-align: center;\n    }\n\n    img {\n      width: auto;\n      height: 58px;\n      max-width: none;\n\n      @media (max-width: 1100px) {\n        height: 48px;\n      }\n\n      @media (max-width: 760px) {\n        height: 46px;\n        margin: 0 auto;\n      }\n\n      @media (max-width: 900px) {\n        margin: 0 auto;\n      }\n    }\n\n    p {\n      margin: 18px 0 0;\n      max-width: 34ch;\n      font-size: 14px;\n      line-height: 1.7;\n      color: $text-secondary;\n\n      @media (max-width: 900px) {\n        margin: 0 auto;\n      }\n    }\n  }\n\n  &__aside {\n    width: 360px;\n    display: grid;\n    grid-template-columns: 170px 118px;\n    column-gap: 42px;\n    justify-content: end;\n    justify-self: end;\n    align-items: start;\n    margin-top: 34px;\n\n    @media (max-width: 1100px) {\n      width: 330px;\n      grid-template-columns: 156px 110px;\n      column-gap: 32px;\n    }\n\n    @media (max-width: 900px) {\n      width: 100%;\n      margin-top: 0;\n      justify-content: space-around;\n      justify-self: start;\n    }\n\n    @media (max-width: 760px) {\n      grid-template-columns: 1fr;\n      row-gap: 20px;\n    }\n  }\n\n  &__nav-section {\n    width: 100%;\n    display: grid;\n    gap: 10px;\n\n    @media (max-width: 760px) {\n      gap: 5px;\n      text-align: center;\n    }\n\n    h3 {\n      margin: 0 0 14px;\n      font-size: 14px;\n      line-height: 1.2;\n      letter-spacing: 0.02em;\n      color: $text-main;\n      font-weight: 700;\n    }\n\n    a {\n      display: block;\n      font-size: 14px;\n      line-height: 1.55;\n      color: $text-main;\n      text-decoration: none;\n      transition: color 0.2s ease;\n\n\n    }\n  }\n\n  &__legal-link {\n    font-size: 14px;\n    line-height: 1.55;\n    color: $text-main;\n    text-decoration: none;\n\n\n  }\n\n  &__contact {\n    font-size: 14px;\n    line-height: 1.55;\n    color: $text-main;\n    text-decoration: none;\n\n\n  }\n\n  &__copy {\n    font-size: 14px;\n    line-height: 1.55;\n    color: $text-main !important;\n    text-decoration: none;\n\n\n  }\n\n  &__bottom_legal-section {\n    font-size: 14px;\n  }\n\n\n  &__bottom {\n    position: relative;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: start;\n    margin-top: 0;\n    padding-top: 20px;\n    gap: 12px 24px;\n    border-top: none;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      width: min(92%, 1200px);\n      height: 1px;\n      background: linear-gradient(90deg, rgba(16, 25, 21, 0) 0%, rgba(16, 25, 21, .05) 14%, rgba(16, 25, 21, .10) 50%, rgba(16, 25, 21, .05) 86%, rgba(16, 25, 21, 0) 100%);\n    }\n\n    &>div:first-child {\n      justify-self: start;\n      text-align: left;\n    }\n\n    &> :nth-child(2) {\n      justify-self: end;\n      text-align: right;\n      max-width: none;\n    }\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr;\n      gap: 10px;\n\n      &::before {\n        width: min(88%, 520px);\n      }\n\n      &>div:first-child,\n      &> :nth-child(2) {\n        justify-self: center;\n        text-align: center;\n        max-width: none;\n      }\n    }\n  }\n\n  &__legal-link,\n  &__contact,\n  &__copy {\n    line-height: 1.55;\n    color: $text-secondary;\n    text-decoration: none;\n  }\n\n  &__copy {\n    white-space: nowrap;\n    text-wrap: nowrap;\n\n    @media (max-width: 900px) {\n      white-space: normal;\n      text-wrap: balance;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__CmMBU`,
	"footer__wrap": `Footer_footer__wrap__tuuWK`,
	"footer__top": `Footer_footer__top__HFgh8`,
	"footer__brand": `Footer_footer__brand__YCxI1`,
	"footer__aside": `Footer_footer__aside__Q-c9k`,
	"footer__nav-section": `Footer_footer__nav-section__JDQV5`,
	"footer__legal-link": `Footer_footer__legal-link__h6K8n`,
	"footer__contact": `Footer_footer__contact__cZxwV`,
	"footer__copy": `Footer_footer__copy__6ju2J`,
	"footer__bottom_legal-section": `Footer_footer__bottom_legal-section__F61PI`,
	"footer__bottom": `Footer_footer__bottom__1IfmQ`
};
export default ___CSS_LOADER_EXPORT___;
